'use client';
import logo from '@/assets/images/logo.png';
import Image from 'next/image';
import { mapModifiers } from '@/utils/funtion';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import { FaFacebookSquare, FaLinkedin } from 'react-icons/fa';
import { FcInvite } from 'react-icons/fc';
import Link from 'next/link';
import { CONTACT, FOOTER_CAREER } from '@/statics/constants';
import { PATH_URL } from '@/statics/static';
import { useData } from '@/stores/context';
import { Collapse } from 'antd';
import { FaYoutubeSquare } from 'react-icons/fa';
const Footer = () => {
  const { innerWidth } = useData();

  const items = [
    // {
    //   key: '1',
    //   label: 'Tài nguyên',
    //   children: (
    //     <div className="app-footer_mobile_item_list">
    //       {FOOTER_RESOURCES.map((item, index) => (
    //         <div className="app-footer_mobile_item_list_i" key={index}>
    //           {item}
    //         </div>
    //       ))}
    //     </div>
    //   ),
    // },
    {
      key: '2',
      label: 'Cơ hội nghề nghiệp',
      children: (
        <div className="app-footer_mobile_item_list">
          {FOOTER_CAREER.map((item, index) => (
            <Link
              className={mapModifiers(
                'app-footer_mobile_item_list_i',
                'career',
              )}
              href={PATH_URL.CAREER}
              key={index}
            >
              {item}
            </Link>
          ))}
        </div>
      ),
    },
    {
      key: '3',
      label: 'Chính sách và điều khoản',
      children: (
        <div className="app-footer_mobile_item_list">
          <Link
            className={mapModifiers('app-footer_mobile_item_list_i', 'career')}
            href="/chinh-sach?policy_type=chinh-sach-bao-ve"
            target="_blank"
          >
            Chính sách bảo vệ dữ liệu cá nhân
          </Link>
          <Link
            className={mapModifiers('app-footer_mobile_item_list_i', 'career')}
            href="/chinh-sach?policy_type=dieu-khoan-dieu-kien-chung"
            target="_blank"
          >
            Điều khoản và điều kiện chung
          </Link>
          <Link
            className={mapModifiers('app-footer_mobile_item_list_i', 'career')}
            href="/faq"
            target="_blank"
          >
            FAQ
          </Link>
        </div>
      ),
    },
    {
      key: '4',
      label: 'Liên hệ',
      children: (
        <div className="app-footer_mobile_item_list">
          <Link
            href="https://forms.gle/TjDcSX2ijyxbQdFg6"
            target="_blank"
            className="app-footer_mobile_item_list_i"
          >
            {'Nhận tư vấn'}
          </Link>
          <Link
            href="https://maps.app.goo.gl/RqyhyZjrW3t1zLYW8"
            target="_blank"
            className="app-footer_mobile_item_list_i"
          >
            {CONTACT.ADDRESS}
          </Link>
          <Link
            className="app-footer_mobile_item_list_i"
            href={`tel:${CONTACT.PHONE}`}
          >
            {CONTACT.PHONE}
          </Link>
          <Link
            className="app-footer_mobile_item_list_i"
            href={`mailto:${CONTACT.EMAIL}`}
          >
            {CONTACT.EMAIL}
          </Link>
        </div>
      ),
    },
  ];

  return (
    <footer className="app-footer">
      <div className="app-footer_wrapper">
        <div className="app-footer_top">
          <div className="app-footer_left">
            <Image src={logo} alt="Logo công ty" loading="lazy" />
            <div className="app-footer_left_slogan">
              <span>Vietstats</span> - Nền tảng tổng hợp dữ liệu kinh tế đáng
              tin cậy, hỗ trợ hoạch định chiến lược, chính sách và ra quyết định
              thông minh cho nhà đầu tư và doanh nghiệp.
            </div>
            {/* <div className="app-footer_left_social">
              <Link
                href={CONTACT.LINKEDIN}
                className="lk"
                target="_blank"
                aria-label="Vietstats LinkedIn"
              >
                <FaLinkedin />
              </Link>
              <Link
                href={CONTACT.FACEBOOK}
                className="fb"
                target="_blank"
                aria-label="Vietstats Facebook"
              >
                <FaFacebookSquare />
              </Link>
              <Link
                href={CONTACT.YOUTUBE}
                className="yt"
                target="_blank"
                aria-label="Vietstats YouTube"
              >
                <FaYoutubeSquare />
              </Link>
            </div> */}
          </div>

          {innerWidth > 800 ? (
            <div className="app-footer_right">
              {/* <div className="app-footer_right_item">
              <div className="app-footer_right_item_title">TÀI NGUYÊN</div>
              <div className="app-footer_right_item_list">
                {FOOTER_RESOURCES.map((item, index) => (
                  <div className="app-footer_right_item_list_i" key={index}>
                    {item}
                  </div>
                ))}
              </div>
            </div> */}
              <div className="app-footer_right_item">
                <div className="app-footer_right_item_title">
                  CƠ HỘI NGHỀ NGHIỆP
                </div>
                <div className="app-footer_right_item_list">
                  {FOOTER_CAREER.map((item, index) => (
                    <Link
                      className={mapModifiers(
                        'app-footer_right_item_list_i',
                        'career',
                      )}
                      href={PATH_URL.CAREER}
                      key={index}
                    >
                      {item}
                    </Link>
                  ))}
                </div>
              </div>
              <div className="app-footer_right_item">
                <div className="app-footer_right_item_title">
                  CHÍNH SÁCH VÀ ĐIỀU KHOẢN
                </div>
                <div className="app-footer_right_item_list">
                  <Link
                    className={mapModifiers(
                      'app-footer_right_item_list_i',
                      'career',
                    )}
                    href="/chinh-sach?policy_type=chinh-sach-bao-ve"
                    target="_blank"
                  >
                    Chính sách bảo vệ dữ liệu cá nhân
                  </Link>
                  <Link
                    className={mapModifiers(
                      'app-footer_right_item_list_i',
                      'career',
                    )}
                    href="/chinh-sach?policy_type=dieu-khoan-dieu-kien-chung"
                    target="_blank"
                  >
                    Điều khoản và điều kiện chung
                  </Link>
                  <Link
                    className={mapModifiers(
                      'app-footer_right_item_list_i',
                      'career',
                    )}
                    href="/chinh-sach?policy_type=dieu-khoan-mua-goi-dich-vu"
                    target="_blank"
                  >
                    Điều khoản mua gói dịch vụ dữ liệu
                  </Link>
                  <Link
                    className={mapModifiers(
                      'app-footer_right_item_list_i',
                      'career',
                    )}
                    href="/faq"
                  >
                    Câu hỏi thường gặp (Q&A)
                  </Link>
                </div>
              </div>
              <div className="app-footer_right_item">
                <div className="app-footer_right_item_title">LIÊN HỆ</div>
                <div className="app-footer_right_item_list">
                  <Link
                    href="https://forms.gle/TjDcSX2ijyxbQdFg6"
                    target="_blank"
                    className="app-footer_right_item_list_i"
                  >
                    <div className="app-footer_right_item_list_i_icon">
                      <FcInvite />
                    </div>
                    {'Nhận tư vấn'}
                  </Link>
                  <Link
                    href="https://maps.app.goo.gl/RqyhyZjrW3t1zLYW8"
                    target="_blank"
                    className="app-footer_right_item_list_i"
                  >
                    <div className="app-footer_right_item_list_i_icon">
                      <FiMapPin />
                    </div>
                    {CONTACT.ADDRESS}
                  </Link>
                  <Link
                    className="app-footer_right_item_list_i"
                    href={`tel:${CONTACT.PHONE}`}
                  >
                    <div className="app-footer_right_item_list_i_icon">
                      <FiPhone />
                    </div>
                    {CONTACT.PHONE}
                  </Link>
                  <Link
                    className="app-footer_right_item_list_i"
                    href={`mailto:${CONTACT.EMAIL}`}
                  >
                    <div className="app-footer_right_item_list_i_icon">
                      <FiMail />
                    </div>
                    {CONTACT.EMAIL}
                  </Link>

                  {/* <div className="app-footer_right_item_list_cert">
                                <div className="app-footer_right_item_list_cert">
                                    <h4>Được chứng nhận bởi</h4>
                                    <a href="http://online.gov.vn/Home/AppDetails/163" target="_blank">
                                        <Image alt="chứng nhận" src="https://homepage.momocdn.net/blogscontents/momo-upload-api-210629153623-637605777831780706.png" width="119" height="45" />
                                    </a>
                                </div>
                            </div> */}
                </div>
              </div>
            </div>
          ) : (
            <Collapse items={items} accordion={true} />
          )}
        </div>
        <div className="app-footer_bottom">
          <div className="app-footer_bottom_left">
            {/* <Image
              src={bct}
              alt="chung-nhan-cua-bo-cong-thuong"
              width={150}
              height={68}
              loading="lazy"
            /> */}
            <p>
              Số GCNĐKDN: 0318370355 - Đăng ký thay đổi lần thứ 1, ngày 08 tháng
              04 năm 2024.
            </p>
          </div>
          <div className="app-footer_bottom_right">
            <div className="app-footer_left_social">
              <Link
                href={CONTACT.LINKEDIN}
                className="lk"
                target="_blank"
                aria-label="Vietstats LinkedIn"
              >
                <FaLinkedin />
              </Link>
              <Link
                href={CONTACT.FACEBOOK}
                className="fb"
                target="_blank"
                aria-label="Vietstats Facebook"
              >
                <FaFacebookSquare />
              </Link>
              <Link
                href={CONTACT.YOUTUBE}
                className="yt"
                target="_blank"
                aria-label="Vietstats YouTube"
              >
                <FaYoutubeSquare />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-end">
        {innerWidth > 800 && (
          <div className="footer-end_left">
            <div className="footer-end_left_logo">
              <Image src={logo} alt="Logo công ty" width={40} loading="lazy" />
            </div>
            <ul>
              <li>
                CÔNG TY TNHH TƯ VẤN CHIẾN LƯỢC CHÍNH SÁCH VÀ PHÂN TÍCH DỮ LIỆU
                KINH TẾ VIETSTATS
              </li>
              <li>{CONTACT.ADDRESS}</li>
            </ul>
          </div>
        )}
        <div className="footer-end_right">
          © Vietstats Corp. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
